var _circle, _mask, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyOptions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319,
    height: 319,
    viewBox: "0 0 319 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 159.5,
    cy: 159.5,
    r: 159.5,
    fill: "url(#paint0_linear)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 319,
    height: 319
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 159.5,
    cy: 159.5,
    r: 159.5,
    fill: "url(#paint1_linear)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.35,
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.001,
    y: 68.0667,
    width: 224.338,
    height: 251.924,
    rx: 1.93237,
    transform: "rotate(-0.0805182 47.001 68.0667)",
    fill: "black"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 47.001,
    y: 68.0667,
    width: 224.338,
    height: 251.924,
    rx: 1.93237,
    transform: "rotate(-0.0805182 47.001 68.0667)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0047 69.1013C47.0032 68.0341 47.8671 67.1677 48.9343 67.1662L269.407 66.8564C270.475 66.8549 271.341 67.7188 271.342 68.786L271.358 79.8369L47.0202 80.1521L47.0047 69.1013Z",
    fill: "#646B7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5934 76.4938C61.3858 76.4913 62.8367 75.0362 62.8342 73.2438C62.8317 71.4515 61.3766 70.0005 59.5843 70.003C57.7919 70.0055 56.3409 71.4606 56.3434 73.253C56.3459 75.0453 57.801 76.4963 59.5934 76.4938Z",
    fill: "#4E5465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5465 76.4938C72.3389 76.4913 73.7899 75.0362 73.7873 73.2438C73.7848 71.4515 72.3298 70.0005 70.5374 70.003C68.745 70.0055 67.294 71.4606 67.2966 73.253C67.2991 75.0453 68.7541 76.4963 70.5465 76.4938Z",
    fill: "#AAAFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0944 76.4938C82.8867 76.4913 84.3377 75.0362 84.3352 73.2438C84.3327 71.4515 82.8776 70.0005 81.0852 70.003C79.2929 70.0055 77.8419 71.4606 77.8444 73.253C77.8469 75.0453 79.302 76.4963 81.0944 76.4938Z",
    fill: "#AAAFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 98.9998,
    width: 166.214,
    height: 80.6063,
    rx: 1.28824,
    transform: "rotate(-0.0805182 75 98.9998)",
    fill: "#F4F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.596 122.44C130.54 126.826 131.135 142.185 134.052 153.431L148.7 155.42L157.858 129.051C156.979 126.118 155.541 123.773 153.396 122.44L145.479 121.358L137.596 122.44Z",
    fill: "#48D29E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.052 153.431C135.223 157.933 136.765 161.777 138.337 163.99C139.11 165.075 139.658 165.706 141.516 165.737H141.819H145.497H149.172H149.475C149.573 165.737 149.668 165.734 149.76 165.728C149.328 165.663 150.137 165.093 150.183 164.646L150.94 157.409L148.406 153.431H134.052Z",
    fill: "#43C594"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.978 141.786L164.595 143.803L165.285 146.467L173.125 147.552L181.474 146.467C183.025 143.061 179.865 138.868 177.686 137.774C176.816 142.148 170.885 141.541 165.978 141.786Z",
    fill: "#FFDB81"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.929 112.509V118.026L145.497 119.261L152.062 118.026V112.509C152.062 112.23 151.832 112 151.55 112H139.441C139.159 112 138.929 112.23 138.929 112.509Z",
    fill: "#365E7D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.928 118.025C138.196 118.025 137.595 118.626 137.595 119.362V122.439H153.395V119.362C153.395 118.626 152.795 118.025 152.062 118.025H138.928V118.025Z",
    fill: "#F9F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.475 146.467H165.285L164.145 148.364L164.761 150.004H183.025V146.81C183.025 146.62 182.872 146.467 182.685 146.467H181.475Z",
    fill: "#F9F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.761 150.004L163.667 157.409V162.074H179.063C181.965 160.784 184 157.872 184 154.506V150.534C184 150.243 183.764 150.004 183.47 150.004H183.026H164.761Z",
    fill: "#234CFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.795 162.074H160.399V164.836C160.399 165.286 160.065 165.66 159.636 165.728C159.688 165.734 159.74 165.737 159.796 165.737H174.581C175.249 165.737 175.795 165.192 175.795 164.523V162.074Z",
    fill: "#365E7D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.705 139.745C178.176 141.565 179.243 144.192 178.207 146.467H179.418H181.474C183.025 143.061 179.865 138.868 177.686 137.774C177.523 138.592 177.183 139.236 176.705 139.745Z",
    fill: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.758 146.81V150.004H180.205H183.025V146.81C183.025 146.62 182.872 146.467 182.685 146.467H181.474H179.417C179.565 146.467 179.69 146.562 179.739 146.694C179.752 146.73 179.758 146.767 179.758 146.81Z",
    fill: "#DDDAEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.736 150.534V154.506C180.736 157.872 178.697 160.784 175.795 162.074H179.062C181.965 160.784 184 157.872 184 154.506V150.534C184 150.243 183.764 150.004 183.47 150.004H183.025H180.205C180.497 150.004 180.736 150.243 180.736 150.534Z",
    fill: "#3259FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.795 162.074V164.523C175.795 165.191 175.249 165.737 174.581 165.737H177.848C178.516 165.737 179.062 165.192 179.062 164.523V162.074H175.795Z",
    fill: "#2B4D66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.897 129.719L145.424 133.284L156.357 137.361L167.234 133.284L167.762 129.719C167.814 129.37 167.673 129.051 167.127 129.051C159.93 129.051 152.731 129.051 145.531 129.051C144.989 129.051 144.845 129.37 144.897 129.719Z",
    fill: "#F9F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.995 157.409V164.836C148.995 165.286 149.329 165.663 149.761 165.728C149.804 165.734 149.85 165.737 149.896 165.737H162.766C162.812 165.737 162.858 165.734 162.901 165.728C163.333 165.66 163.667 165.286 163.667 164.836V162.074V157.409C161.261 157.409 159.315 154.506 156.908 154.506C154.423 154.506 151.48 157.409 148.995 157.409Z",
    fill: "#F9F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.84 136.094L148.406 153.431L148.994 157.409H163.666L164.761 150.004L165.285 146.467L165.977 141.786L167.234 133.284H158.716H145.423L145.84 136.094Z",
    fill: "#365E7D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.329 140.959C154.042 140.959 152.185 142.85 152.185 145.186C152.185 147.521 154.042 149.415 156.329 149.415C156.881 149.415 157.405 149.305 157.883 149.109L157.904 149.1C159.029 148.628 159.909 147.662 160.28 146.467C160.405 146.065 160.473 145.633 160.473 145.186C160.473 144.597 160.356 144.036 160.142 143.527C159.86 142.856 159.415 142.274 158.854 141.832C158.156 141.284 157.279 140.959 156.329 140.959Z",
    fill: "#E97B93"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.995 165.737H162.765C162.811 165.737 162.857 165.734 162.9 165.728C163.332 165.66 163.666 165.287 163.666 164.836V162.074V157.409H160.89V162.074V164.836C160.89 165.287 160.559 165.66 160.126 165.728C160.084 165.734 160.038 165.737 159.995 165.737Z",
    fill: "#DDDAEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.988 129.719L164.461 133.284H167.235L167.762 129.719C167.814 129.37 167.673 129.051 167.127 129.051H164.354C164.896 129.051 165.04 129.37 164.988 129.719Z",
    fill: "#DDDAEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.298 134.384L163.201 141.786L163.158 142.09L162.509 146.467L161.987 150.004L161.034 156.447L160.89 157.409H163.667L164.761 150.004L165.285 146.467L165.978 141.786L167.235 133.284H164.461L164.298 134.384Z",
    fill: "#2B4D66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.699 145.186C157.699 145.633 157.632 146.065 157.503 146.467C157.132 147.662 156.256 148.628 155.128 149.1L155.109 149.109C155.054 149.13 154.999 149.152 154.941 149.173C155.376 149.329 155.842 149.415 156.329 149.415C156.881 149.415 157.405 149.305 157.883 149.109L157.905 149.1C159.03 148.628 159.909 147.662 160.28 146.467C160.406 146.065 160.473 145.633 160.473 145.186C160.473 144.597 160.357 144.036 160.142 143.527C159.86 142.856 159.416 142.274 158.855 141.832C158.156 141.284 157.28 140.959 156.329 140.959C155.842 140.959 155.376 141.045 154.941 141.201C155.355 141.351 155.738 141.566 156.078 141.832C156.639 142.274 157.086 142.856 157.368 143.527C157.58 144.036 157.699 144.597 157.699 145.186Z",
    fill: "#E06A84"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.372 161.452C153.08 161.452 152.841 161.691 152.841 161.982V163.72V165.737H159.817V161.982C159.817 161.691 159.578 161.452 159.287 161.452H154.116H153.372Z",
    fill: "#D0CEE7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.692 112.509V118.026H147.689H147.692H152.06H152.063V112.509C152.063 112.23 151.833 112 151.551 112H147.183C147.462 112 147.692 112.23 147.692 112.509Z",
    fill: "#2B4D66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.811 118.635C148.949 118.847 149.028 119.095 149.028 119.362V122.439H153.396V119.362C153.396 118.626 152.795 118.025 152.063 118.025H152.06H147.692C148.161 118.025 148.575 118.271 148.811 118.635Z",
    fill: "#DDDAEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.028 122.439C151.17 123.773 152.608 126.118 153.487 129.051H156.329H157.858C156.978 126.118 155.541 123.773 153.395 122.439H149.028Z",
    fill: "#51DFAA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.456 153.562C169.116 153.562 168.028 154.672 168.028 156.039C168.028 157.406 169.116 158.516 170.456 158.516C171.795 158.516 172.88 157.406 172.88 156.039C172.88 154.672 171.795 153.562 170.456 153.562Z",
    fill: "#2F56FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.045 136.094C131.79 141.713 132.655 148.042 134.052 153.431H148.406L145.84 136.094H132.045Z",
    fill: "#F9F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182 194.775C182 191.585 184.586 189 187.775 189H197.225C200.414 189 203 191.585 203 194.775C203 197.964 200.414 200.55 197.225 200.55H187.775C184.586 200.55 182 197.964 182 194.775Z",
    fill: "#234CFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.225 198.975C199.544 198.975 201.425 197.094 201.425 194.775C201.425 192.455 199.544 190.575 197.225 190.575C194.905 190.575 193.025 192.455 193.025 194.775C193.025 197.094 194.905 198.975 197.225 198.975Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 192.046,
    width: 33.1271,
    height: 5.73632,
    rx: 2.86816,
    transform: "rotate(-0.0805182 209 192.046)",
    fill: "#A4AEAF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 186.035,
    width: 24.9447,
    height: 6.65931,
    rx: 3.32966,
    transform: "rotate(-0.0805182 75 186.035)",
    fill: "#234CFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.0176,
    y: 197.274,
    width: 49.5038,
    height: 6.65931,
    rx: 3.32966,
    transform: "rotate(-0.0805182 75.0176 197.274)",
    fill: "#E0E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182 224.775C182 221.585 184.586 219 187.775 219H197.225C200.414 219 203 221.585 203 224.775C203 227.964 200.414 230.55 197.225 230.55H187.775C184.586 230.55 182 227.964 182 224.775Z",
    fill: "#234CFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.225 228.975C199.544 228.975 201.425 227.094 201.425 224.775C201.425 222.455 199.544 220.575 197.225 220.575C194.905 220.575 193.025 222.455 193.025 224.775C193.025 227.094 194.905 228.975 197.225 228.975Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 222.046,
    width: 33.1271,
    height: 5.73632,
    rx: 2.86816,
    transform: "rotate(-0.0805182 209 222.046)",
    fill: "#A4AEAF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 216.035,
    width: 24.9447,
    height: 6.65931,
    rx: 3.32966,
    transform: "rotate(-0.0805182 75 216.035)",
    fill: "#234CFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.0176,
    y: 227.274,
    width: 49.5038,
    height: 6.65931,
    rx: 3.32966,
    transform: "rotate(-0.0805182 75.0176 227.274)",
    fill: "#E0E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182 254.775C182 251.585 184.586 249 187.775 249H197.225C200.414 249 203 251.585 203 254.775C203 257.964 200.414 260.55 197.225 260.55H187.775C184.586 260.55 182 257.964 182 254.775Z",
    fill: "#DFE2E7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.225 258.975C190.544 258.975 192.425 257.094 192.425 254.775C192.425 252.455 190.544 250.575 188.225 250.575C185.905 250.575 184.025 252.455 184.025 254.775C184.025 257.094 185.905 258.975 188.225 258.975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 252.046,
    width: 33.1271,
    height: 5.73632,
    rx: 2.86816,
    transform: "rotate(-0.0805182 209 252.046)",
    fill: "#E0E7E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 246.035,
    width: 24.9447,
    height: 6.65931,
    rx: 3.32966,
    transform: "rotate(-0.0805182 75 246.035)",
    fill: "#234CFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.0176,
    y: 257.274,
    width: 49.5038,
    height: 6.65931,
    rx: 3.32966,
    transform: "rotate(-0.0805182 75.0176 257.274)",
    fill: "#E0E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.5 163C190.5 167.694 186.695 171.5 182 171.5C177.305 171.5 173.5 167.694 173.5 163C173.5 158.305 177.305 154.5 182 154.5C186.694 154.5 190.5 158.305 190.5 163Z",
    fill: "#1EB27A",
    stroke: "#F4F5F8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.571 163.571V167H181.429V163.571H178V162.428H181.429V159H182.571V162.428H186V163.571H182.571Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -96.9961,
    y: -72.2458,
    width: 512.686,
    height: 540.233,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 72
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 159.5,
    y1: 0,
    x2: 159.5,
    y2: 319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE4F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 159.5,
    y1: 0,
    x2: 159.5,
    y2: 319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE4F1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "matrix(1 0 0 -1 178 167)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyOptions);
export default __webpack_public_path__ + "static/media/empty-options.a5f63a2232f3d12c2f35326d8c344abb.svg";
export { ForwardRef as ReactComponent };